export default "__VITE_ASSET__43fa5515__"